import React, { useState } from 'react';
import { TaskNotification } from '../../types/tasks';
import TaskIcon, { TaskIconName } from './TaskIcon';

const KIND_ICON: Record<TaskNotification['kind'], TaskIconName> = {
  assigned: 'assigned',
  scheduled: 'scheduled',
  recurring: 'recurring',
  auto: 'auto',
  shared: 'share',
  follow_up: 'waiting',
  completed: 'check',
  note: 'note',
  unblocked: 'carry',
};

const COLLAPSED_COUNT = 3;

// "Order more boxes was added to this week's list, assigned to you" — shown
// at the top of Lists the first time you open it after something new lands.
const NotificationBanner: React.FC<{
  notifications: TaskNotification[];
  onShow: (n: TaskNotification) => void;
  onDismiss: (id: number) => void;
  onDismissAll: () => void;
}> = ({ notifications, onShow, onDismiss, onDismissAll }) => {
  const [expanded, setExpanded] = useState(false);
  if (!notifications.length) return null;
  const visible = expanded ? notifications : notifications.slice(0, COLLAPSED_COUNT);
  const hiddenCount = notifications.length - visible.length;

  return (
    <div className="tk-banner" role="status" aria-live="polite">
      <div className="tk-banner-head">
        <span className="tk-banner-title">
          <TaskIcon name="bell" size={15} />
          {notifications.length === 1 ? 'New for you' : `${notifications.length} new for you`}
        </span>
        <button type="button" className="tk-link-btn" onClick={onDismissAll}>Dismiss all</button>
      </div>
      <ul className="tk-banner-list">
        {visible.map((n) => (
          <li key={n.id} className={`tk-banner-item tk-banner-${n.kind}`}>
            <span className="tk-banner-icon"><TaskIcon name={KIND_ICON[n.kind]} size={14} /></span>
            <span className="tk-banner-msg">{n.message}</span>
            {(n.item_id || n.list_id) && (
              <button type="button" className="tk-link-btn" onClick={() => onShow(n)}>Show</button>
            )}
            <button type="button" className="tk-icon-btn tk-icon-btn-sm" onClick={() => onDismiss(n.id)} aria-label="Dismiss">
              <TaskIcon name="close" size={13} />
            </button>
          </li>
        ))}
      </ul>
      {hiddenCount > 0 && (
        <button type="button" className="tk-link-btn tk-banner-more" onClick={() => setExpanded(true)}>
          and {hiddenCount} more
        </button>
      )}
    </div>
  );
};

export default NotificationBanner;
